// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  display: flex;
  justify-content: center;
}

ngu-carousel::ng-deep {
  height: 100%;
  width: 100%;
  max-width: 220px;
}
ngu-carousel::ng-deep .ngucarousel, ngu-carousel::ng-deep .ngu-touch-container {
  height: 100%;
}
ngu-carousel::ng-deep .ngu-touch-container {
  margin: 0 20px;
  overflow: hidden;
}
ngu-carousel::ng-deep ngu-tile {
  width: 33.3333%;
  flex: 33.3333% 0 0;
}
ngu-carousel::ng-deep .item {
  padding: 4px;
}
ngu-carousel::ng-deep .tile {
  height: 100%;
  box-shadow: none;
  display: flex;
  justify-content: center;
}

img {
  width: unset !important;
  object-position: center;
}

.thumbnail {
  position: relative;
  width: 100%;
  height: 50px;
  min-width: 100%;
  padding: 2px 0;
  margin: 0 6px;
  cursor: pointer;
  border: 1px solid #5c0a31;
  display: flex;
  justify-content: center;
}
.thumbnail.active-image {
  border: 2px solid #5c0a31;
}
.thumbnail img {
  max-width: 100%;
  max-height: 100%;
}

app-360-image-icon {
  position: absolute;
  left: 7px;
  top: 8px;
  z-index: 10;
  height: 10px;
  width: 19px;
}
app-360-image-icon::ng-deep svg {
  height: 10px;
  width: 19px;
}

.carousel-navigator {
  position: absolute;
  top: calc(50% - 20px);
  height: 41px;
  width: 19px;
  background-color: rgba(128, 128, 128, 0.7);
  border: none;
  border-radius: 0;
  opacity: 0.5;
  cursor: pointer;
  z-index: 1;
}
.carousel-navigator.disabled {
  opacity: 0;
}
.carousel-navigator.carousel-left {
  left: 0px;
  outline: none;
}
.carousel-navigator.carousel-right {
  right: 0px;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/page/components/product/components/product-image/product-image-thumbnail-carousel/product-image-thumbnail-carousel.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AADF;AAGE;EACE,YAAA;AADJ;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,kBAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AALJ;;AASA;EACE,uBAAA;EACA,uBAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AANF;AAQE;EACE,yBAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AARF;AAWI;EACE,YAAA;EACA,WAAA;AATN;;AAcA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAXF;AAaE;EACE,UAAA;AAXJ;AAcE;EACE,SAAA;EACA,aAAA;AAZJ;AAeE;EACE,UAAA;EACA,aAAA;AAbJ","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n:host {\n  display: flex;\n  justify-content: center;\n}\n\nngu-carousel::ng-deep {\n  height: 100%;\n  width: 100%;\n  max-width: 220px;\n\n  .ngucarousel, .ngu-touch-container {\n    height: 100%;\n  }\n\n  .ngu-touch-container {\n    margin: 0 20px;\n    overflow: hidden;\n  }\n\n  ngu-tile {\n    width: 33.3333%;\n    flex: 33.3333% 0 0;\n  }\n\n  .item {\n    padding: 4px;\n  }\n\n  .tile {\n    height: 100%;\n    box-shadow: none;\n    display: flex;\n    justify-content: center;\n  }\n}\n\nimg {\n  width: unset !important;\n  object-position: center;\n}\n\n.thumbnail {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  min-width: 100%;\n  padding: 2px 0;\n  margin: 0 6px;\n  cursor: pointer;\n  border: 1px solid $wine-red-light;\n  display: flex;\n  justify-content: center;\n\n  &.active-image {\n    border: 2px solid $wine-red-light;\n  }\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n  }\n}\n\napp-360-image-icon {\n  position: absolute;\n  left: 7px;\n  top: 8px;\n  z-index: 10;\n  height: 10px;\n  width: 19px;\n\n  &::ng-deep {\n    svg {\n      height: 10px;\n      width: 19px;\n    }\n  }\n}\n\n.carousel-navigator {\n  position: absolute;\n  top: calc(50% - 20px);\n  height: 41px;\n  width: 19px;\n  background-color: rgba(128, 128, 128, 0.7);\n  border: none;\n  border-radius: 0;\n  opacity: 0.5;\n  cursor: pointer;\n  z-index: 1;\n\n  &.disabled {\n    opacity: 0;\n  }\n\n  &.carousel-left {\n    left: 0px;\n    outline: none;\n  }\n\n  &.carousel-right {\n    right: 0px;\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
